module.exports = __webpack_public_path__ + "assets/img/disk.7ff59ff3.png";